export const createStyles = (theme?: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    minWidth: 0,
    fontFamily: theme?.typography?.fontFamily,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'stretch', md: 'flex-end' },
    gap: '8px',
    flexWrap: 'wrap',
  },
  viewSubmissionsButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    height: '42px',
    width: { xs: '100%', md: 'auto' },
  },
});
